import { API_URL } from "../config/apiConfig";

const request = async (path, options = {}) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${API_URL}/contract-request-plans${path}`, {
        ...options,
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

    const contentType = response.headers.get("content-type") || "";
    const data = response.status === 204
        ? null
        : contentType.includes("application/json")
            ? await response.json()
            : await response.text();

    if (!response.ok) {
        const message = data?.message || data?.error || (typeof data === "string" && data) ||
            `Request failed with status ${response.status}`;
        throw new Error(message);
    }

    return data;
};

export const getContractRequestPlans = () => request("");

export const createContractRequestPlan = (plan) => request("", {
    method: "POST",
    body: JSON.stringify(plan),
});

export const updateContractRequestPlan = (id, plan) => request(`/${id}`, {
    method: "PUT",
    body: JSON.stringify(plan),
});

export const deleteContractRequestPlan = (id) => request(`/${id}`, {
    method: "DELETE",
});

export const getAffiliateContractRequestPlans = (affiliateId) =>
    request(`/affiliate/${affiliateId}`);

export const submitContractRequest = (id, requestData) => request(`/${id}/submit`, {
    method: "POST",
    body: JSON.stringify(requestData),
});
